import React, { useState } from 'react';
import adventure from '../../../assets/images/adventure.png';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';

export default function SoloTravelForm() {
    const place = useSelector((state) => state.place);
    const [loading, setLoading] = useState(false);

    const blockedDomains = [
        "yopmail.com",
        "mailinator.com",
        "tempmail.com",
        "temporary-mail.net",
        "temp-mail.org",
        "10minutemail.com",
        "guerrillamail.com",
        "trashmail.com",
        "fakeinbox.com",
        "getnada.com",
        "dispostable.com"
    ];

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors }
    } = useForm();

    const onSubmit = async (formData) => {
        const { name, email, travelerType } = formData;

        const domain = email.split('@')[1]?.toLowerCase();
        if (blockedDomains.includes(domain)) {
            toast.error('Temporary / Disposable email domains are not allowed');
            return;
        }

        setLoading(true);

        try {
            const response = await fetch(
                `https://backend.mysittivacations.com/api/user-subscription?email=${encodeURIComponent(email)}&firstName=${encodeURIComponent(name)}&city=${encodeURIComponent(place)}&travelerType=${encodeURIComponent(travelerType)}`,
                {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            );

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || 'Failed to submit form');
            }

            toast.success(data.message || 'Submitted successfully');
            reset();
        } catch (error) {
            console.error(error);
            toast.error(error.message || 'Submission failed');
        } finally {
            setLoading(false);
        }
    };

    return (
        <section className="section-equal-padding favorite-section uk-scrollspy-inview"
            style={{ backgroundImage: `url(${adventure})` }}
            uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
            <div className="container-fluid">
                <div className="favorite-block adventure_sec  uk-scrollspy-inview"
                    uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false">
                    <div className="row">
                        <div className="col-md-6">
                            <h2 className="mb-2">Your solo female adventure in {place?.split(',')[0]?.replace(/\b\w/g, x => x?.toUpperCase())} {""} awaits you.</h2>
                            <p>Your solo adventure in {place?.split(',')[0]?.replace(/\b\w/g, x => x?.toUpperCase())} {""} awaits you! Dive into turquoise Start Planning waters, explore
                                vibrant
                                streets, and dance under the stars. Ready for an unforgettable journey?</p>
                        </div>
                        <div className="col-md-6">
                            <form onSubmit={handleSubmit(onSubmit)} className="adventure_form mt-4 mt-md-0">
                                <div className="input_ d-flex row row-cols-1 row-cols-md-2">
                                    {/* Name */}
                                    <div className="col mb-3">
                                        <input
                                            type="text"
                                            className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                                            placeholder="First Name"
                                            {...register('name', {
                                                required: 'Name is required',
                                                minLength: {
                                                    value: 2,
                                                    message: 'Name should be at least 2 characters',
                                                },
                                            })}
                                        />
                                        {errors.name && (
                                            <div className="invalid-feedback">{errors.name.message}</div>
                                        )}
                                    </div>

                                    {/* Email */}
                                    <div className="col mb-3">
                                        <input
                                            type="email"
                                            className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                                            placeholder="Enter Email"
                                            {...register('email', {
                                                required: 'Email is required',
                                                pattern: {
                                                    value: emailRegex,
                                                    message: 'Please enter a valid email address',
                                                },
                                            })}
                                        />
                                        {errors.email && (
                                            <div className="invalid-feedback">{errors.email.message}</div>
                                        )}
                                    </div>
                                </div>

                                {/* Traveler Type */}
                                <div className="select_dropdown mb-3">
                                    <select
                                        className={`form-control ${errors.travelerType ? 'is-invalid' : ''}`}
                                        {...register('travelerType', {
                                            required: 'Traveler Type is required',
                                        })}
                                    >
                                        <option value="">Select Type</option>
                                        <option value="LGBTQ">LGBTQ</option>
                                        <option value="Solo Female">Solo Female</option>
                                        <option value="General">General</option>
                                        <option value="Family">Family</option>
                                        <option value="Couple">Couple</option>
                                    </select>
                                    {errors.travelerType && (
                                        <div className="mt-0 invalid-feedback">{errors.travelerType.message}</div>
                                    )}
                                </div>

                                <button type="submit" className="white-btn w-100 text-center" disabled={loading}>
                                    {loading ? 'Submitting...' : 'Start Planning'}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
